import { useState } from 'react';
import UpdateTicker from './UpdateTicker';

const navLinks = [
  { label: '主播精选', href: '#anchors' },
  { label: '话题墙', href: '#topics' },
  { label: '热门内容', href: '#hot' },
  { label: '分类专区', href: '#boards' },
  { label: '近期更新', href: '#updates' },
  { label: '常见问题', href: '#faq' },
];

export default function SiteHeader() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 w-full">
      <UpdateTicker />
      <div className="relative bg-background-50/92 backdrop-blur-md border-b border-background-200">
        <div className="flex items-center justify-between gap-4 h-16 px-4 md:px-6">
          <a href="#top" className="flex items-center gap-2.5 shrink-0 cursor-pointer">
            <span className="w-9 h-9 md:w-10 md:h-10 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 font-heading text-lg font-black">
              蓝
            </span>
            <span className="leading-tight">
              <span className="block font-heading text-base md:text-lg font-black tracking-tight text-foreground-950">
                小蓝视频
              </span>
              <span className="block text-[10px] md:text-xs font-label text-foreground-500">
                内容浏览指南
              </span>
            </span>
          </a>

          <nav className="hidden lg:flex items-center gap-1">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className="px-3 py-2 rounded-md text-sm font-label text-foreground-700 hover:text-foreground-950 hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap"
              >
                {link.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <a
              href="#topics"
              className="hidden md:flex items-center gap-2 h-10 pl-3 pr-4 rounded-full border border-background-300 bg-background-50 text-foreground-500 hover:border-primary-300 hover:text-foreground-700 transition-colors cursor-pointer"
            >
              <i className="ri-search-line text-base"></i>
              <span className="text-sm font-label whitespace-nowrap">搜索主播 / 话题</span>
            </a>
            <a
              href="#faq"
              className="hidden sm:flex items-center gap-1.5 h-10 px-4 rounded-md bg-primary-500 text-background-50 text-sm font-label font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-feedback-line text-base"></i>
              内容反馈
            </a>
            <button
              type="button"
              onClick={() => setOpen((value) => !value)}
              aria-label="展开导航"
              className="lg:hidden w-10 h-10 flex items-center justify-center rounded-md border border-background-300 text-foreground-800 hover:bg-background-100 transition-colors cursor-pointer"
            >
              <i className={open ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'}></i>
            </button>
          </div>
        </div>

        {open && (
          <div className="lg:hidden absolute left-0 right-0 top-full bg-background-50 border-b border-background-200 px-4 pb-4 pt-2">
            <div className="grid grid-cols-2 gap-2">
              {navLinks.map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  onClick={() => setOpen(false)}
                  className="px-3 py-2.5 rounded-md bg-background-100 text-sm font-label text-foreground-800 hover:bg-primary-50 hover:text-primary-700 transition-colors cursor-pointer"
                >
                  {link.label}
                </a>
              ))}
            </div>
            <a
              href="#faq"
              onClick={() => setOpen(false)}
              className="mt-3 flex items-center justify-center gap-1.5 h-11 rounded-md bg-primary-500 text-background-50 text-sm font-label font-medium cursor-pointer"
            >
              <i className="ri-feedback-line text-base"></i>
              内容反馈
            </a>
          </div>
        )}
      </div>
    </header>
  );
}